export async function useClientLogo() {
    const { $Amplify } = useNuxtApp();
    const readerIdStore = useReaderIdStore();
    const key = computed(
        () => `client-logo:${readerIdStore.readerId || "unknown"}`,
    );

    const { data, pending, error, refresh } = useAsyncData(
        key,
        async () => {
            if (!readerIdStore.readerId) return "/favicon.png";

            try {
                const { url } = await $Amplify.Storage.getUrl({
                    path: `clients/${readerIdStore.readerId}/logo.png`,
                    options: { expiresIn: 172800, validateObjectExistence: true },
                });
                return url.toString();
            } catch (err) {
                console.warn(err);
                return "/favicon.png";
            }
        },
        {
            server: true,
            lazy: false,
            default: () => "/favicon.png",
            watch: [() => readerIdStore.readerId],
        },
    );

    return {
        logoUrl: computed(() => data.value || "/favicon.png"),
        pending,
        error,
        refresh,
    };
}
